var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeaveRequestList',{attrs:{"activeTabIndex":0,"title":"Pending"}})
}
var staticRenderFns = []

export { render, staticRenderFns }